"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./Checkbox.scss");
const Checkbox = ({ name = '', checked = false, onChange, onClick, value, id, children, disabled = false, readonly = false, indeterminate = false, dataCy, style = {}, customContainerClass, labelClass, size, isCenter = true }) => {
    return (react_1.default.createElement("div", { className: `single-checkbox-container ${customContainerClass}`, style: style, onClick: (e) => e.stopPropagation() },
        react_1.default.createElement("input", { type: "checkbox", className: `checkbox-happy5 ${indeterminate ? 'indeterminate' : ''}`, checked: indeterminate ? false : checked, name: name, value: value, id: id, onClick: (e) => {
                !disabled && onClick && onClick(e);
            }, onChange: (e) => {
                !disabled && onChange && onChange(e);
            }, disabled: disabled, readOnly: readonly }),
        react_1.default.createElement("label", { className: `${size === 'small' ? 'small' : ''} ${labelClass} mb-[0px] ${disabled ? 'disabled' : 'cursor-pointer'} ${isCenter ? 'is-center' : 'items-start'}`, "data-cy": dataCy, htmlFor: id }, children)));
};
exports.default = Checkbox;
